import type { ReactNode } from 'react';
import { useMyPermissions } from '../api/queries';
import { useTranslate } from '../i18n/useTranslate';
import { ErrorView } from '../ui/ErrorView';

/**
 * İzinler YÜKLENENE KADAR hiçbir şey çizilmez (SEOAI-47 incelemesi).
 *
 * Neden gerekli: kurum değişiminde izinler anında sıfırlanır (session.applySession)
 * ve yeni yanıt gelene kadar izin kümesi BOŞTUR. Bu aralıkta menü/route çizilse
 * kullanıcı bir an için "hiçbir şeye erişemiyor" görünür, hatta Forbidden ekranı
 * yanıp söner. Veriyi backend zaten korur; sorun arayüzün KISA SÜRE yanlış karar
 * vermesidir.
 *
 * Yükleniyor durumu bilinçli olarak sade: kurum geçişi milisaniyeler sürer.
 */
export function PermissionsGate({ children }: { children: ReactNode }) {
  const t = useTranslate();
  const permissions = useMyPermissions();

  if (permissions.isPending) return <p>{t('permissions.loading')}</p>;
  if (permissions.isError) {
    return <ErrorView error={permissions.error} onRetry={() => void permissions.refetch()} />;
  }

  return <>{children}</>;
}
